var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.960449H513V342.964H0V0.960449Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.833 171.957C224.107 171.652 224.377 171.347 224.648 171.039C224.377 171.348 224.101 171.65 223.826 171.957H223.833ZM189.586 213.966L200.566 236.923L225.361 231.194L214.257 254.092L234.195 269.904L209.371 275.5L209.44 300.947L189.586 285.026L169.734 300.947L169.803 275.5L144.979 269.904L164.917 254.092L153.813 231.194L178.607 236.923L189.586 213.966ZM387.832 242.485L393.069 253.436L404.895 250.702L399.599 261.624L409.109 269.166L397.268 271.834L397.3 283.972L387.832 276.379L378.363 283.972L378.396 271.834L366.555 269.166L376.065 261.624L370.77 250.702L382.596 253.436L387.832 242.485ZM339.114 126.32L344.351 137.271L356.177 134.537L350.881 145.459L360.39 153.002L348.55 155.67L348.582 167.809L339.114 160.214L329.645 167.809L329.678 155.67L317.836 153.002L327.346 145.459L322.052 134.537L333.877 137.271L339.114 126.32ZM387.832 59.9404L393.069 70.8918L404.895 68.1564L399.599 79.0797L409.108 86.6214L397.268 89.2906L397.3 101.428L387.832 93.8335L378.363 101.428L378.396 89.2906L366.555 86.6214L376.065 79.0797L370.77 68.1564L382.596 70.8918L387.832 59.9404ZM430.386 109.725L435.623 120.676L447.448 117.942L442.154 128.864L451.663 136.405L439.822 139.075L439.855 151.212L430.386 143.62L420.917 151.212L420.949 139.075L409.109 136.405L418.619 128.864L413.323 117.942L425.149 120.676L430.386 109.725ZM399.959 167.809L404.077 180.485H417.407L406.623 188.321L410.743 200.997L399.959 193.163L389.173 200.997L393.293 188.321L382.509 180.485H395.839L399.959 167.809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 0.960449V31.5731L211.245 56.7211H256.5V116.196H197.282L256.5 149.095V171.957H229.768L156.13 131.051V171.957H100.37V123.289L12.7689 171.957H0V141.344L45.2552 116.196H0V56.7211H59.2184L0 23.811V0.960449H26.7321L100.37 41.8672V0.960449H156.13V49.6283L243.731 0.960449H256.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.281 0.95752H112.219V70.4249H0V102.487H112.219V171.957H144.281V102.487H256.5V70.4249H144.281V0.95752Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.13 116.196L256.5 171.957V156.189L184.513 116.196H156.13Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.13 116.196L256.5 171.957V156.189L184.513 116.196H156.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.13 116.196L256.5 171.957V156.189L184.513 116.196H156.13ZM71.9863 116.196L0 156.189V171.957L100.37 116.196H71.9863Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.37 56.7182L0 0.95752V16.7253L71.9873 56.7182H100.37Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.37 56.7182L0 0.95752V16.7253L71.9873 56.7182H100.37Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.37 56.7182L0 0.95752V16.7253L71.9873 56.7182H100.37ZM184.514 56.7182L256.5 16.7253V0.95752L156.13 56.7182H184.514Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1041"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.960449)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHm);
export default __webpack_public_path__ + "static/media/HM.2f09209439b7728de56a2a150b3b88ed.svg";
export { ForwardRef as ReactComponent };